<template>
  <section>
    <div v-if="!loading && !selectedDate" class="next-slots">
      <SlotSelector v-if="nextAvailableSlots" ref="slotSelectorNext" @change="selectedSlotChanged"
        :selectedServiceIds="selectedServiceIds" :selectedProviderId="selectedProviderId" :selectedDate="undefined"
        :reservationId="reservationId" :scheduleInfo="scheduleInfo" :slotsToShow="nextAvailableSlotsToShow"
        :selectedSlot="selectedSlot" :slotTitleKey="'Label.NextAvailableSlots'"></SlotSelector>
    
    </div>
    <div><a v-if="closeProviderSlots.length" @click="scrollToClosestSlots" href="javascript:void(0)">{{ t.getOrKey("Label.ScrollToSlotsInOtherProviders") }}</a></div>

    <h4>{{ t.getOrKey("Label.SelectSlot") }}</h4>

    <Loader :loading="loading">
      <Datepicker :inline="true" :monday-first="true" :language="currentLang" @selected="selectedDateChanged"
        :disabled-dates="disabledDates" @changedMonth="monthChanged" v-model="selectedDate"
        :open-date="calendarStartDate"></Datepicker>
      <SlotSelector v-if="selectedDate" ref="slotSelector" @change="selectedSlotChanged"
        :selectedServiceIds="selectedServiceIds" :selectedProviderId="selectedProviderId" :selectedDate="selectedDate"
        :selectedSlot="selectedSlot" :reservationId="reservationId" :scheduleInfo="scheduleInfo"></SlotSelector>
    </Loader>
    <Loader :loading="additionalSlotsLoading" class="close-slots-wrap" v-if="!selectedDate">
      <h3 id="close-provider-slots" v-if="closeProviderSlots.length">Ensimmäiset vapaat ajat muissa lähimmissä korjaamoissa</h3>
      <div v-for="providerWithSlots in closeProviderSlots" :key="providerWithSlots.id" class="close-slots">
        <SlotSelector @change="(slot) => selectedSlotAndProviderChanged(slot, providerWithSlots)"
          :selectedServiceIds="selectedServiceIds" :selectedProviderId="providerWithSlots.id" :selectedDate="undefined"
          :reservationId="reservationId" :scheduleInfo="undefined" :slotsToShow="providerWithSlots.nextAvailableSlots"
          :slotTitleKey="providerWithSlots.name" :onBeforeSelect="onBeforeOtherProviderSelect(providerWithSlots)"
          :selectedSlot="selectedSlot" ref="closeProviderSlots"></SlotSelector>
      </div>
    </Loader>
  </section>
</template>
<script>
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import * as lang from "vuejs-datepicker/src/locale";
import t from "@/services/translation-service";
import api from "@/services/api-service";
import Loader from "./Loader";
import SlotSelector from "./SlotSelector";
import utils from './../services/utils';
const dayInMs = 1000 * 60 * 60 * 24;
const CLOSE_KM_LIMIT = 30;
const MAX_DAYS_IN_FUTURE_TO_GET_CLOSE_SLOTS = 7;
const MIN_EXTRA_PROVIDERS = 3;
const MAX_EXTRA_PROVIDERS = 3;
export default {
  components: {
    Datepicker,
    Loader,
    SlotSelector,
  },
  props: {
    selectedServiceIds: Array,
    selectedProviderId: String,
    reservationId: String,
    scheduleInfo: String,
    closeProviders: [],
    selectedSlot: Object
  },
  watch: {
    selectedServiceIds(newVal, oldVal) {
      if (!utils.arrayContainsIdenticalItems(newVal, oldVal)) {
        this.updateAvailability();
      }
    },
    selectedProviderId() {
      this.updateAvailability();
    },
  },
  created() {
    this.updateAvailability();
  },
  computed: {
    nextAvailableSlotsToShow() {
      return this.nextAvailableSlots.slice(0, 4);
    },
  },
  methods: {
    scrollToClosestSlots(){
      document.getElementById('close-provider-slots').scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
    },
    onBeforeOtherProviderSelect(provider) {
      if (this.selectedProviderId === provider.id) {
        return () => true
      }
      const msg = `Valitsit ajan korjaamosta ${provider.name}. Valitaanko tämä korjaamo ja varataan aika?`;
      return () => confirm(msg);
    },
    selectedDateChanged(newDate) {
      this.selectedDate = newDate;
      this.clearSlotSelectorData();
    },
    monthChanged(month) {
      api
        .getAvailability(
          this.selectedServiceIds,
          this.selectedProviderId,
          month
        )
        .then((data) => {
          const newBlockedDates = data.blockedDays.map((f) => new Date(f.replace("Z", "")));
          const allNew = [...this.disabledDates.dates.filter(f => f.getMonth() !== month.getMonth()), ...newBlockedDates];
          const newDisabledDates = Object.assign({}, this.disabledDates, {dates: allNew});
          this.disabledDates = newDisabledDates;
        });
    },
    clearSlotSelectorData() {
      if (this.$refs.slotSelector) {
        this.$refs.slotSelector.clearData();
      }
      if (this.$refs.slotSelectorNext) {
        this.$refs.slotSelectorNext.clearData();
      }
      if (!this.skipCloseReload) {
        this.selectedSlotChanged(undefined);
      }
    },
    clearData() {
      this.selectedDate = undefined;
      if (!this.skipCloseReload) {
        this.closeProviderSlots = [];
      }
      this.clearSlotSelectorData();
    },
    selectedSlotAndProviderChanged(slot, provider) {
      this.skipCloseReload = true;
      this.clearCloseProviderStates(slot);
      this.$emit("change", { ...slot, provider: provider })
    },
    clearCloseProviderStates(slot) {
      if (this.$refs.closeProviderSlots) {
        this.$refs.closeProviderSlots.map(r => {
          r.setCurrentSlot(slot);
        });
      }
    },
    selectedSlotChanged(slot) {
      this.clearCloseProviderStates(slot);
      this.$emit("change", slot);
    },
    reloadSlots() {
      this.$refs.slotSelector.getSlots();
    },
    handlePossibleExtraProviderAvailability() {
      const now = new Date();

      if (this.nextAvailableSlots.every(f => ((new Date(f.start) - now) / dayInMs) > MAX_DAYS_IN_FUTURE_TO_GET_CLOSE_SLOTS)) {
        const additionalProviders = this.closeProviders.filter(f => f.distance < CLOSE_KM_LIMIT) ?? [];
        if (additionalProviders.length < MIN_EXTRA_PROVIDERS && this.closeProviders?.some(() => true)) {
          let i = 0;
          while (additionalProviders.length < MIN_EXTRA_PROVIDERS && this.closeProviders.filter(f => !additionalProviders.some(a => a.id === f.id)).length > additionalProviders.length) {
            additionalProviders.push(this.closeProviders.filter(f => !additionalProviders.some(a => a.id === f.id))[i]);
            i++;
            if (i > 100) break;
          }
        }
        this.additionalSlotsLoading = true;
        const additionalSlots = additionalProviders.slice(0, MAX_EXTRA_PROVIDERS + 2).map(f => {
          return api
            .getAvailability(this.selectedServiceIds, f.id)
            .then((data) => {
              return { ...f, availability: data }
            })
        });
        Promise.allSettled(additionalSlots).then(res => {
          this.additionalSlotsLoading = false;
          const closeProviderSlots = res
            .filter(f => f.status === 'fulfilled' && !!f.value?.availability?.nextAvailableSlots?.length)
            .map(f => ({ ...f.value, nextAvailableSlots: f.value.availability.nextAvailableSlots.sort((a, b) => new Date(a.start) > new Date(b.start) ? 1 : -1).slice(0, 4) }))
            .sort((a, b) => new Date(a.nextAvailableSlots[0].start) - new Date(b.nextAvailableSlots[0].start))
            .slice(0, MAX_EXTRA_PROVIDERS);
          this.closeProviderSlots = closeProviderSlots ?? [];
        });
      }
    },
    updateAvailability() {
      this.loading = true;
      this.disabledDates = undefined;
      if (
        this.selectedServiceIds &&
        this.selectedServiceIds.length &&
        this.selectedProviderId
      ) {
        api
          .getAvailability(this.selectedServiceIds, this.selectedProviderId)
          .then((data) => {
            this.disabledDates = {
              to: new Date(data.calendarStartDate.replace("Z", "")),
              from: new Date(data.calendarEndDate),         
              days: data.ignoreDaysOfWeek,   
              dates: data.blockedDays.map((f) => new Date(f.replace("Z", ""))),
            };
            this.calendarStartDate = new Date(data.calendarStartDate.replace("Z", ""));
            this.nextAvailableSlots = data.nextAvailableSlots ?? [];
            if (!this.selectedDate && !this.skipCloseReload) {
              this.handlePossibleExtraProviderAvailability();
            }
          })
          .finally(() => {
            this.loading = false;
            this.skipCloseReload = false;
          });
      } else {
        this.loading = false;
      }
    },
  },
  data() {
    return {
      currentLang: lang[t.getCurrentLanguage()],
      disabledDates: undefined,
      selectedDate: undefined,
      loading: true,
      nextAvailableSlots: [],
      calendarStartDate: undefined,
      t: t,
      closeProviderSlots: [],
      additionalSlotsLoading: false,
      skipCloseReload: false,
    };
  },
};
</script>
<style>
section .vdp-datepicker .cell.selected {
  background-color: #0047bb !important;
  color: white !important;
}

h4 {
  width: 100%;
  display: block;
  text-align: left;
}
</style>
<style scoped>
.next-slots .slot-container {
  margin-left: 0;
}

section>div {
  text-align: center;
}

.vdp-datepicker {
  margin-bottom: 2rem;
  display: inline-block;
}

/* Date and time selection */
section>div {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.close-slots-wrap {
  display: flex;
  flex-direction: column;
}

.close-slots {
  width: 100%;
}

.close-slots .slot-container {
  margin-left: 0;
}

@media screen and (max-width: 767px) {
  section>div {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
